var video_viewer_default = {
  "video_player": "gBxr-",
  "videoOverlay": "U1wEy",
  "video_container": "_86JRO"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
